import { Component, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-icon',
  imports: [],
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.less'
})
export class IconComponent {
  @Input() icon: string = 'help';
  @Input() size: number = 24;
  @Input() color: string = 'currentColor';
  @Input() fill: boolean = false;
  @Input() noMove: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['icon']) {
      if (!(window as any).icons_used) {
        (window as any).icons_used = [];
      }
      if (!(window as any).icons_used.includes(this.icon)) {
        (window as any).icons_used.push(this.icon);
      }
    }
  }
}
